import React from 'react'

import Widget from '@/components/widget/Widget'

import { AiAnswersTable } from './AiAnswersTable'

/**
 * @import import { AiAnswersSearchLog } from '@/views/AiAnswers/AiAnswersSearchLog'
 * @param {object} props
 * @param {object[]} props.rows The search log rows
 * @param {boolean} props.loading Whether the search log is fetching; never the verified answers'
 *   fetch, since a change of loading resets the table's search and page
 * @param {object} props.dateRange The page's date range, for the CSV download
 * @param {object[]} [props.actions] Row actions for the table
 */
export const AiAnswersSearchLog = ({ rows, loading, dateRange, actions }) => (
  <Widget
    label="Search log"
    subtitle="Every question your agents asked AgentGPT"
    showCsvDownload
    displayBackground={false}
  >
    <AiAnswersTable loading={loading} rows={rows} dateRange={dateRange} actions={actions} />
  </Widget>
)
